<script>
import CookieLaw from 'vue-cookie-law'
import TheHero from '@/components/Home/TheHero'
import BetterFoundation from '@/components/Home/BetterFoundation'
import CustomizableTools from '@/components/Home/CustomizableTools'
import ClinicalArc from '@/components/Home/ClinicalArc'
import SupportBlocks from '@/components/Home/SupportBlocks.vue'
import PlatformStatement from '@/components/Home/PlatformStatement.vue'
import CallToAction from '@/components/Home/CallToAction.vue'
// import ToolFeedback from '@/components/PromoSite/HomePageOLD/ToolFeedback'
import StrategicPartnerships from '@/components/Home/StrategicPartnerships'
import TestimonialsBlock from '@/components/Home/TestimonialsBlock'
import ComprehensiveApproach from '@/components/Home/ComprehensiveApproach'
import TherapyManagementBlock from '@/components/Home/TherapyManagementBlock'
// import BookPromo from '@/components/PromoSite/HomePageOLD/BookPromo'
import { mapGetters } from 'vuex'
import { goToRef } from '@/mixins/global'


export default {
  name: 'HomeView',
  components: {
    TheHero,
    BetterFoundation,
    CustomizableTools,
    SupportBlocks,
    StrategicPartnerships,
    TestimonialsBlock,
    ComprehensiveApproach,
    TherapyManagementBlock,
    ClinicalArc,
    PlatformStatement,
    CallToAction,
    CookieLaw
  },
  mixins: [goToRef],
  data () {
    return {
      showTree: false,
      heroSlideDur: 0.5
    }
  },
  computed: {
    ...mapGetters({
      libraryInfo: 'brochure/libraryInfo',
      workingLibrary: 'ovb/workingLibrary'
    }),
    heroHeight () {
      return this.$mq === 'mobile' ? '60vh' : '70vh'
    },
    heroSlides () {
      return [
        {
          title: '<div class="hero-title mb-2 text-outline-light">Vision Therapy Across<br>the Full Arc</div>',
          content: '<div class="hero-content mb-5 text-outline-dark">From skill building to real-world carryover</div>',
          // buttonLabel: 'Learn More',
          duration: this.heroSlideDur,
          // event: 'GOTO_GAMING'
        },
        {
          title: '<div class="hero-title mb-2">Therapy that Progresses<br>with Your Patient</div>',
          content: '<div class="hero-content mb-5">One platform across changing therapy demands</div>',
          // buttonLabel: 'Learn More',
          duration: this.heroSlideDur
          // event: 'GOTO_FEATURES'
        },
        {
          title: '<div class="hero-title mb-2">Built to Sustain Compliance</div>',
          content: '<div class="hero-content mb-5">Engagement designed to support consistent therapy work</div>',
          // buttonLabel: 'Learn More',
          duration: this.heroSlideDur
          // event: 'GOTO_FEATURES'
        }
      ]
    },
    isLoading () {
      return this.loading > 0
    },
    currentRoute () {
      return this.$router.currentRoute
    },
    isMobile () {
      return ((this.$mq === 'mobile') || (this.$mq === 'tablet'))
    },
    isLoggedIn () {
      return this.$store.getters['user/isLoggedIn']
    }
  },
  mounted () {
    // Check for logout query parameter
    if (this.$route.query.logout) {
      const logoutType = this.$route.query.logout
      let message = 'You\'ve been logged out successfully'

      if (logoutType === 'expired') {
        message = 'Your session has expired. You\'ve been logged out successfully.'
      }

      // Show logout toast notification
      this.$buefy.toast.open({
        message: message,
        type: 'is-success',
        duration: 3000,
        position: 'is-top'
      })

      // Clear the query parameter from URL without reloading
      this.$router.replace({ name: 'HomeView' })
    }

    // If user is already logged in, redirect to their home page
    // This handles the case where authenticated users navigate to the home page
    if (this.$store.getters['user/isLoggedIn'] && this.$store.state.user.userInfo) {
      const homePath = this.$store.state.user.userInfo.homePath
      if (homePath) {
        this.$router.push({ name: homePath })
      }
    }
  },
  methods: {
    onGotoGaming () {
      this.$router.push({ name: 'FeaturesView' })
    }
  }
}
</script>

<template>
  <section
    class='home-view'
  >
    <div
      class="home-view-no-auth"
    >
      <the-hero
        :height="heroHeight"
        :auto-play="true"
        :slides="heroSlides"
        @GOTO_GAMING="onGotoGaming"
      />
      <div class="better-foundation-section py-6" ref="betterFoundation">
        <article class="container mobile-container">
          <better-foundation />
        </article>
      </div>
      <section class="customizable-tools py-6">
        <article class="container mobile-container">
          <customizable-tools />
        </article>
      </section>
      <section class="support-blocks py-6">
        <article class="container mobile-container">
          <support-blocks />
        </article>
      </section>
      <section class="clinical-arc-section py-6">
        <article class="container mobile-container">
          <clinical-arc />
        </article>
      </section>
      <section class="platform-statement-section py-6">
        <article class="container mobile-container">
          <platform-statement />
        </article>
      </section>
<!--      <section class="comprehensive-approach py-6">-->
<!--        <article class="container mobile-container">-->
<!--          <comprehensive-approach />-->
<!--        </article>-->
<!--      </section>-->
      <section class="call-to-action-section py-6">
        <article class="container mobile-container">
          <call-to-action />
        </article>
      </section>
      <section class="strategic-partnerships-section py-6">
        <article class="container mobile-container">
          <strategic-partnerships />
        </article>
      </section>
<!--      <section class="therapy-management py-6">-->
<!--        <article class="container mobile-container">-->
<!--          <therapy-management-block />-->
<!--        </article>-->
<!--      </section>-->
<!--      <section class="testimonials-block py-4">-->
<!--        <article class="">-->
<!--          <testimonials-block />-->
<!--        </article>-->
<!--      </section>-->
<!--      <section class="book-promo-section py-6">-->
<!--        <article class="container mobile-container">-->
<!--          <book-promo />-->
<!--        </article>-->
<!--      </section>-->
<!--      <tool-feedback />-->
    </div>
    <!-- PRETTY SURE THIS GOES AWAY -->
<!--    <div-->
<!--      v-if="!userInfo.appUserId"-->
<!--      class="free-demo"-->
<!--    >-->
<!--      <button-->
<!--        @click="onFreeTrial"-->
<!--        class="is-hidden-mobile text-outline-light is-rounded is-watermelon button is-large is-family-semibold">-->
<!--        Start Your Free Trial!-->
<!--      </button>-->
<!--    </div>-->
  </section>
</template>

<style
  lang="scss"
  scoped
>
  .home-view {
    .free-demo {
      position: fixed;
      top: 6rem;
      right: 2rem;
      z-index: 99;
    }
  }
  .slide-section, .player-container, .slide, .video-slide, .slide-overlay {
    height: 50rem;
  }
  .better-foundation-section {
    background: $empty-background;
  }
  .customizable-tools {
    background-color: $white;
  }
  .support-blocks {
    background-color: $empty-background;
  }
  .promo-requirements-section {
    background-color: $dark-blue;
  }
  .comprehensive-approach {
    background-color: $empty-background;
  }
  .clinical-arc-section {
    background-color: #B5DCF0;
  }
  .call-to-action-section {
    background-color: $watermelon;
  }
  .strategic-partnerships-section {
    background-color: $eggshell;
  }
  .testimonials-block {
    background-color: $toothpaste;
    max-width: 100vw;
    overflow: hidden;
  }
  .book-promo-section {
    background-color: $tangerine;
  }
</style>
